import 'globalEffects';
// keep global effects at top //
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from '@sentry/react';
import appQueryClient from 'api/appQueryClient';
import ReportUTMs from 'components/atoms/ReportUTMs';
import ToastContainerWithOffset from 'components/atoms/ToastContainerWithOffset';
import GlobalModalsRoot from 'components/organisms/GlobalModalsService/GlobalModalsRoot.component';
import { TrustpilotReview } from 'components/organisms/TrustpilotReview';
import ErrorPage from 'components/pages/Error.component';
import * as config from 'config';
import { AIMetadataProvider } from 'contexts/AIMetadataProvider';
import MoneyTransferProvider from 'contexts/MoneyTransferProvider';
import i18n from 'i18n';
import 'index.css';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import 'react-loading-skeleton/dist/skeleton.css';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import 'theme/fonts.scss';

window.addEventListener('vite:preloadError', (event) => {
  console.error(event.payload);
  Sentry.captureException(event.payload, {
    level: 'error',
    tags: {
      vite: true,
    },
  });
});

const loadApp = async () => {
  let AppComponent = (await import(`./applications/${config.product}/App`))
    .default;

  AppComponent = Sentry.withProfiler(AppComponent);

  AppComponent = Sentry.withErrorBoundary(AppComponent, {
    fallback: (props) => <ErrorPage {...(props as any)} />,
  });

  return AppComponent;
};

// Only if not inside an iframe, render the app.
if (window == window.parent) {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  loadApp().then((App) => {
    root.render(
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={appQueryClient}>
          <GoogleOAuthProvider
            clientId={import.meta.env.VITE_APP_GOOGLE_CLIENTID as string}
          >
            {/* <ReactQueryDevtools position="top-left" /> */}
            <BrowserRouter>
              <AIMetadataProvider>
                <MoneyTransferProvider>
                  <ReportUTMs />
                  <TrustpilotReview />
                  <App />
                  <GlobalModalsRoot />
                </MoneyTransferProvider>
                <ToastContainerWithOffset />
              </AIMetadataProvider>
            </BrowserRouter>
          </GoogleOAuthProvider>
        </QueryClientProvider>
      </I18nextProvider>,
    );
  });
}
